import type { ReactNode, ReactText } from 'react';
import type { IconName } from '../Icon';

export const TagAlertPalette = {
  neutral: 'neutral',
  notice: 'notice',
  success: 'success',
  caution: 'caution',
  cautionDark: 'cautionDark',
};

export const TagAlertSize = {
  small: 'small',
  medium: 'medium',
};

/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
export type TagAlertIconMapType = {
  readonly [key: string]: {
    readonly name: IconName;
  };
};

export type GarnishProps = {
  readonly size?: SizeTypes;
  readonly palette?: PaletteTypes;
};

export type TagAlertChildren = {
  readonly children: ReactText | ReactNode;
};

export type TagAlertProps = GarnishProps & TagAlertChildren;
export type TagAlertTextProps = GarnishProps & TagAlertChildren;
export type TagAlertBoxProps = GarnishProps & TagAlertChildren;

export type PaletteTypes = Required<keyof typeof TagAlertPalette>;
export type SizeTypes = Required<keyof typeof TagAlertSize>;
